import React, { useEffect, useState } from 'react';

import { useLanguage } from 'Context/LanguageContext';

import ActiveInactiveStatus from '~/ActiveInactiveStatus/ActiveInactiveStatus.component';

function CellType({ isochronous }) {
	const { type } = isochronous;

	const lan = useLanguage();

	const [isCircle, setIsCircle] = useState(false);

	useEffect(() => setIsCircle(type === 1), [type, lan]);

	return <ActiveInactiveStatus isActive={isCircle} textActive={lan.circle} textInactive={lan.polygon} />;
}

export default CellType;
